function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { isPresent } from '@ember/utils';
const HTTP_STATUS_NOT_FOUND = 404;
const HTTP_STATUS_RATE_LIMIT = 429;
export let CatalogErrorType = /*#__PURE__*/function (CatalogErrorType) {
  CatalogErrorType["BAD_REQUEST"] = "BAD_REQUEST";
  CatalogErrorType["VERSION_MISMATCH"] = "VERSION_MISMATCH";
  CatalogErrorType["OBJECT_NOT_FOUND"] = "OBJECT_NOT_FOUND";
  CatalogErrorType["TOO_MANY_ATTRIBUTES"] = "TOO_MANY_ATTRIBUTES";
  CatalogErrorType["NOT_FOUND"] = "NOT_FOUND";
  CatalogErrorType["RATE_LIMIT"] = "RATE_LIMIT";
  CatalogErrorType["OFFLINE"] = "OFFLINE";
  CatalogErrorType["RPC_ERROR"] = "RPC_ERROR";
  CatalogErrorType["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
  CatalogErrorType["OTHER"] = "OTHER";
  CatalogErrorType["ITEMS_INVALID_CANADIAN_FREE_TEXT_DONATION_CATEGORY"] = "ITEMS_INVALID_CANADIAN_FREE_TEXT_DONATION_CATEGORY";
  return CatalogErrorType;
}({});

// TODO: this might be or could be defined elsewhere perhaps at @square/dashboard-utilities/utils/xhr

export default class CatalogError extends Error {
  constructor({
    catalogErrorType,
    message,
    badObject,
    xhrStatus
  }) {
    let wrappedMessage = `CatalogError of type ${catalogErrorType}: ${message}`;
    if (badObject) {
      wrappedMessage = `${wrappedMessage} invalid object: ${JSON.stringify(badObject)}`;
    }
    super(wrappedMessage);
    _defineProperty(this, "catalogErrorType", void 0);
    _defineProperty(this, "badObject", void 0);
    _defineProperty(this, "xhrStatus", void 0);
    this.catalogErrorType = catalogErrorType;
    this.badObject = badObject;
    this.xhrStatus = xhrStatus;
  }
  static fromXhrError(error) {
    let catalogErrorType = CatalogErrorType.OTHER;
    if (isPresent(error?.status)) {
      const statusString = error.status.toString();
      switch (error.status) {
        case 0:
          catalogErrorType = CatalogErrorType.OFFLINE;
          break;
        case HTTP_STATUS_NOT_FOUND:
          catalogErrorType = CatalogErrorType.NOT_FOUND;
          break;
        case HTTP_STATUS_RATE_LIMIT:
          catalogErrorType = CatalogErrorType.RATE_LIMIT;
          break;
        default:
          if (statusString.startsWith('4')) {
            catalogErrorType = CatalogErrorType.BAD_REQUEST;
          } else if (statusString.startsWith('5')) {
            catalogErrorType = CatalogErrorType.INTERNAL_SERVER_ERROR;
          } else {
            catalogErrorType = CatalogErrorType.RPC_ERROR;
          }
          break;
      }
    }
    const message = `XhrError calling "${error?.url}". Status ${error?.status}, detail: ${error?.responseJSON?.errors?.[0]?.detail}`;
    return new this({
      catalogErrorType,
      message,
      xhrStatus: error?.status
    });
  }
}
export function errorIsCatalogError(err) {
  return err !== null && typeof err === 'object' && 'catalogErrorType' in err;
}